import http from '../../../common/Http';


/**
 * 获取首页列表
 */
function consoleInit(){
    let url = '/v1/console/init';
    return http("get",url);
}


/**
 * 各服务用量折线图
 */
function getUsageCharts(service = undefined){
    let url = '/v1/console/trend';
    return http("get",url,{
        service: service
    });
}


export {
    consoleInit,
    getUsageCharts,

}
